import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService, MerchantUserService } from 'app/services';
import { MerchantConfirmOnboardingComponent } from 'app/components/merchant/merchant-confirm-onboarding/merchant-confirm-onboarding.component';
import { MerchantUploadDocumentTypeEnum } from 'app/components/merchant';
import { PersonalIdType, PersonalIdTypeEnum } from 'app/models';
import * as moment from 'moment';
import { Utils } from 'app/utils';

@Component({
    selector: 'merchant-upload-document',
    templateUrl: './merchant-upload-document.component.html',
    styleUrls: ['./merchant-upload-document.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'],
    providers: [MessageService]
})
export class MerchantUploadDocumentComponent implements OnInit {
    @Input() public headerTitleText: string = '';

    public showMerchantUploadDocumentSideBar: boolean = false;
    @Input()
    set _showMerchantUploadDocumentSideBar(value: boolean) {
        this.showMerchantUploadDocumentSideBar = value;
    }

    @Input() public merchantConfirmOnboardingComponent!: MerchantConfirmOnboardingComponent;

    public activeMerchantUploadDocumentType!: MerchantUploadDocumentTypeEnum;
    @Input()
    set _activeMerchantUploadDocumentType(value: MerchantUploadDocumentTypeEnum) {
        this.activeMerchantUploadDocumentType = value;
        if (value === MerchantUploadDocumentTypeEnum.PersonalIdentification) {
            this.regexDocNumber = /^[0-9a-zA-Z\\-\\/]+$/;
        }
    }

    public isRejectedDocument: boolean = false;
    @Input()
    set _isRejectedDocument(value: boolean) {
        this.isRejectedDocument = value;
    }

    @Output() changedShowMerchantUploadDocumentSideBarEmit = new EventEmitter<any>();
    changedShowMerchantUploadDocumentSideBar(increased: any) {
        this.changedShowMerchantUploadDocumentSideBarEmit.emit(increased);
    }

    public merchant: any = {};
    @Input()
    set _merchant(obj: any) {
        this.merchant = obj;
    }

    constructor(private messageService: MessageService,
        private merchantService: MerchantService, private merchantUserService: MerchantUserService) { }

    public merchantUploadDocumentTypeEnum = MerchantUploadDocumentTypeEnum;

    public document: any = {};
    public isIssueDateEmpty: boolean = false;
    public isExpirationDateEmpty: boolean = false;
    public isDocumentNumberEmpty: boolean = false;
    public isPersonalIdTypeEmpty: boolean = false;

    public personalIdTypes = PersonalIdType.PersonalIdTypeList;
    public labelDocumentNumber: string = 'Registration Number';
    public licenseNumber: string = 'License Number';

    public loading: boolean = false;

    private regexDocNumber: RegExp = /^[0-9A-Za-z\-\/]*$/;

    public today: Date = new Date();
    public tomorrow: Date = new Date(this.today.getTime() + (24 * 60 * 60 * 1000));

    progressInterval: any;
    progressBar: number = 0;
    uploadInProgress: boolean = false;

    ngOnInit(): void {
    }

    public validateField(event: any) {
        if (this.document.PersonalIdType !== null && this.document.PersonalIdType !== undefined) {
            this.isPersonalIdTypeEmpty = false;
            if (this.document.PersonalIdType === PersonalIdTypeEnum.DriverLicense) {
                this.labelDocumentNumber = 'License Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.Passport) {
                this.labelDocumentNumber = 'Passport Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.TinCard) {
                this.labelDocumentNumber = 'TIN Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.HealthId) {
                this.labelDocumentNumber = 'PhilHealth Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.OfwId) {
                this.labelDocumentNumber = 'OFW ID Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.VotersId) {
                this.labelDocumentNumber = 'Voter`s Identification Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.UmidId) {
                this.labelDocumentNumber = 'Common Reference Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.NationalId) {
                this.labelDocumentNumber = 'PhilSys Number';
            }
            else if (this.document.PersonalIdType === PersonalIdTypeEnum.PrcId) {
                this.labelDocumentNumber = 'Registration Number';
            }
        }
        else {
            this.isPersonalIdTypeEmpty = true;
        }

        if (this.document.IssueDate !== null && this.document.IssueDate !== undefined) {
            this.isIssueDateEmpty = false;
        }
        else {
            this.isIssueDateEmpty = true;
        }

        if (this.activeMerchantUploadDocumentType !== MerchantUploadDocumentTypeEnum.CompanyAuthorizationLetter) {
            if (this.document.ExpirationDate !== null && this.document.ExpirationDate !== undefined) {
                this.isExpirationDateEmpty = false;
            }
            else {
                this.isExpirationDateEmpty = true;
            }
        }

        if (this.document.DocumentNumber !== null && this.document.DocumentNumber !== undefined) {
            this.isDocumentNumberEmpty = false;
            if (!this.regexDocNumber.test(this.document.DocumentNumber)) {
                this.isDocumentNumberEmpty = true;
            }
        }
        else {
            this.isDocumentNumberEmpty = true;
        }
    }

    public checkFields() {
        switch(this.activeMerchantUploadDocumentType) {
            case MerchantUploadDocumentTypeEnum.SECDocuments:
                if(!this.document.IssueDate || !this.document.DocumentNumber || !this.document.ImageUrl){
                    return true;
                } else {
                    return false;
                }
            case MerchantUploadDocumentTypeEnum.BIR2303Document:
                if(!this.document.IssueDate || !this.document.DocumentNumber || !this.document.ImageUrl){
                    return true;
                } else {
                    return false;
                }
            case MerchantUploadDocumentTypeEnum.PersonalIdentification:
                if(!this.document.ExpirationDate || !this.document.DocumentNumber || !this.document.ImageUrl || !this.document.PersonalIdType){
                    return true;
                } else {
                    return false;
                }
            case MerchantUploadDocumentTypeEnum.CompanyAuthorizationLetter:
                if(!this.document.IssueDate){
                    return true;
                } else {
                    return false;
                }
            default:
                return true;
        }
    }

    public clickUpload() {
        if (!this.regexDocNumber.test(this.document.DocumentNumber)) {
            this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Document number is not subject to this format' });
            this.loading = false;
            return;
        }

        if (this.activeMerchantUploadDocumentType === MerchantUploadDocumentTypeEnum.SECDocuments) {
            this.uploadDocumentToMerchant({
                MerchantId: this.merchant.MerchantId,
                SECDocumentIssueDate: moment(Utils.utcToLocaleString(this.document.IssueDate)).toDate(),
                SECDocumentNumber: this.document.DocumentNumber,
                SECDocumentImageUrl: this.document.ImageUrl
            });
        }
        else if (this.activeMerchantUploadDocumentType === MerchantUploadDocumentTypeEnum.BIR2303Document) {
            this.uploadDocumentToMerchant({
                MerchantId: this.merchant.MerchantId,
                BirDateIssue: moment(Utils.utcToLocaleString(this.document.IssueDate)).toDate(),
                BIR2303DocumentNumber: this.document.DocumentNumber,
                BIR2303DocumentImageUrl: this.document.ImageUrl
            });
        }
        else if (this.activeMerchantUploadDocumentType === MerchantUploadDocumentTypeEnum.PersonalIdentification) {
            this.uploadDocumentToMerchantUser({
                MerchantUserId: this.merchant.MerchantUserId,
                PersonalIdType: this.document.PersonalIdType,
                PersonalIdentificationIssueDate: null,
                PersonalIdentificationExpirationDate: moment(Utils.utcToLocaleString(this.document.ExpirationDate)).toDate(),
                PersonalIdentificationNumber: this.document.DocumentNumber,
                PersonalIdentificationImageUrl: this.document.ImageUrl
            });
        }
        else if (this.activeMerchantUploadDocumentType === MerchantUploadDocumentTypeEnum.CompanyAuthorizationLetter) {
            this.uploadDocumentToMerchantUser({
                MerchantUserId: this.merchant.MerchantUserId,
                CompanyAuthorizationLetterIssueDate: moment(Utils.utcToLocaleString(this.document.IssueDate)).toDate(),
                CompanyAuthorizationLetterExpirationDate: null,
                CompanyAuthorizationLetterNumber: '',
                CompanyAuthorizationLetterImageUrl: this.document.ImageUrl
            });
        }
        this.messageService.add({ severity: 'success', summary: 'Document Uploaded Successfully.', detail: '' });
    }

    public uploadDocumentToMerchant(dto: any) {
        this.loading = true;
        this.merchantService.merchantDocumentUpload(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.merchantConfirmOnboardingComponent.getMerchantUserAndMerchantForConfirmed().then(resolve => {
                if (resolve === 'Success') {
                    this.changedShowMerchantUploadDocumentSideBar({ isRejectedDocument: false, showSideBar: false });
                }
            }
            ).catch(error => {
                console.log(error);
            });
            this.loading = false;
        });
    }

    public uploadDocumentToMerchantUser(dto: any) {
        this.loading = true;
        this.merchantUserService.merchantUserDocumentUpload(dto, this.messageService).then(data => {
            if (!data) {
                this.loading = false;
                return;
            }

            if (!data.Success) {
                this.loading = false;
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.merchantConfirmOnboardingComponent.getMerchantUserAndMerchantForConfirmed().then(resolve => {
                if (resolve === 'Success') {
                    this.changedShowMerchantUploadDocumentSideBar({ isRejectedDocument: false, showSideBar: false });
                }
            }
            ).catch(error => {
                console.log(error);
            });
            this.loading = false;
        });
    }

    public handleImageClick(id: string): void {
        document.getElementById(id)?.click();
    }

    public handleImageChange(event: Event) {
        this.uploadInProgress = true;
        this.progressInterval = setInterval(() => {
            if (this.progressBar === 100) {
                clearInterval(this.progressInterval);
            } else {
                this.progressBar += 5;
            }
        }, 75);
        const target = event.target as HTMLInputElement;

        let file: File | null = null;

        if (target.files) {
            file = target.files[0];
        }

        if (!file) {
            return;
        }

        // Chech max file size 2MB
        if (file.size > 2097152) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid file format. Please upload a valid document.' });
            return;
        }

        const pattern = /image-*/;
        if (!file.type.match(pattern)) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid file format. Please upload a valid document.' });
        return;
        }

        const reader = new FileReader();

        reader.onload = (e) => {
            if (e?.target?.result) {
                // Base64 string
                this.document.ImageUrl = e.target.result.toString();
            }
        };

        reader.readAsDataURL(file);
        this.uploadInProgress = false;
    }

    cancel() {
        this.changedShowMerchantUploadDocumentSideBarEmit.emit({ isRejectedDocument: this.isRejectedDocument, showSideBar: false });
    }
}
